
  import { getMatchedComponents, setScrollRestoration } from './utils'
  if (process.client) {
    if ('scrollRestoration' in window.history) {
      setScrollRestoration('manual')
      window.addEventListener('beforeunload', () => {
        setScrollRestoration('auto')
      })
      window.addEventListener('load', () => {
        setScrollRestoration('manual')
      })
    }
  }

  function shouldScrollToTop(route) {
    const Pages = getMatchedComponents(route)
    if (Pages.length === 1) {
      const {options = {}} = Pages[0]
      return options.scrollToTop !== false
    }
    return Pages.some(({options}) => options && options.scrollToTop)
  }

export default async function (to, from, savedPosition) {
    const findEl = async (hash, x) => {
      return await document.querySelector(hash) ||
        new Promise((resolve) => {
          if (x > 50) {
            return resolve()
          }
          setTimeout(() => {
            resolve(findEl(hash, ++x || 1))
          }, 100)
        })
    }

    if (to.hash) {
      try {
        const el = await findEl(to.hash)
        if (el instanceof HTMLElement) {
          el.classList.add('transition-colors', 'duration-1000', 'bg-primary/10')
          if ('scrollBehavior' in document.documentElement.style) {
            setTimeout(() => {
              el.classList.remove('bg-primary/10')
            }, 600)
            return window.scrollTo({top: el.offsetTop, behavior: 'smooth'})
          } else {
            return window.scrollTo(0, el.offsetTop)
          }
        }
      } catch (e) {
      }
    }

    // If the returned position is falsy or an empty object, will retain current scroll position
    let position = false
    const isRouteChanged = to !== from
    const nuxt = window.$nuxt
    const metaScrollPos = nuxt.context.route.meta?.[0]?.scrollPos
    if (savedPosition || metaScrollPos) {
      position = savedPosition || metaScrollPos
    } else if (isRouteChanged && shouldScrollToTop(to)) {
      position = {x: 0, y: 0}
    }
    if (
      !isRouteChanged ||
      // Route hash changes
      (to.path === from.path && to.hash !== from.hash)
    ) {
      nuxt.$nextTick(() => nuxt.$emit('triggerScroll'))
    }
    return new Promise((resolve) => {
      nuxt.$once('triggerScroll', () => {
        if (to.hash) {
          let hash = to.hash
          if (typeof window.CSS !== 'undefined' && typeof window.CSS.escape !== 'undefined') {
            hash = '#' + window.CSS.escape(hash.substr(1))
          }
          try {
            const el = document.querySelector(hash)
            if (el) {
              position = {selector: hash}
              const y = Number(getComputedStyle(el)['scroll-margin-top']?.replace('px', ''))
              if (y) {
                position.offset = {y}
              }
            }
          } catch (e) {
              console.warn('Failed to save scroll position. Please add CSS.escape() polyfill (https://github.com/mathiasbynens/CSS.escape).')
          }
        }
        resolve(position)
      })
    })
  }
